import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/settings")
      .then((r) => alive && setSettings(r.data))
      .catch(() => alive && setSettings(null));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, update: setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);

export const DEFAULT_WA = "905000000000";